import React from 'react';
import { SelectWrapper, Label, FieldContainer, FloatingLabel, StyledSelect, ErrorMessage } from './styles';

export default function SelectInput({ label, name, value, onChange, onBlur, options, error, placeholder, disabled }) {
  const hasValue = !!value;

  return (
    <SelectWrapper>
      {label && <Label htmlFor={name}>{label}</Label>}
      <FieldContainer $hasError={!!error} $disabled={disabled}>
        {hasValue && placeholder && <FloatingLabel>{placeholder}</FloatingLabel>}
        <StyledSelect
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          $hasError={!!error}
          $hasValue={hasValue}
          disabled={disabled}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </StyledSelect>
      </FieldContainer>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </SelectWrapper>
  );
}
